/* eslint-disable camelcase */
import { Expose, plainToClass, Transform } from 'class-transformer';
import CompsetModel from '@/modules/compsets/models/compset.model';
import RankingDocument from '@/modules/ranking/models/ranking-document.model';
import PromotionsDocumentModel from '@/modules/promotions/models/promotions-document.model';
import RatesDocumentAllModel from '@/modules/rates/models/rates-document-all.model';
import DeepAnalysisDocumentModel from '@/modules/deep-analysis/models/deep-analysis-document.model';
import HotelModel from '@/modules/hotels/models/hotel.model';
import RatesCompsetMainModel from './rates-compset-main.model';
import MarketsCompsetMainModel from './markets-compset-main.model';
import ClusterInsightsDocumentModel from './cluster-insights-document.model';

interface BEHotel {
    id: string;
    name: string;
    geo_location: { longitude: number, latitude: number };
}

export class ClusterHotelDataModel {
    @Expose()
    @Transform((_, plain) => plain.hotelId)
    hotelId!: string;

    @Expose()
    @Transform((_, plain) => (plain.hotels as BEHotel[])?.map(hotel => plainToClass(HotelModel, hotel, { excludeExtraneousValues: true })) || null)
    hotels: HotelModel[] | null = null;

    @Expose()
    @Transform((_, plain) => plainToClass(CompsetModel, plain.compsets, { excludeExtraneousValues: true }) || null)
    compsets: CompsetModel[] | null = null;
}

export class RateClusterHotelDataModel extends ClusterHotelDataModel {
    @Expose()
    @Transform((_, plain) => plainToClass(RatesCompsetMainModel, plain.main_compset, { excludeExtraneousValues: true }) || null)
    document: RatesCompsetMainModel | null = null;
}

export class MarketClusterHotelDataModel extends ClusterHotelDataModel {
    @Expose()
    @Transform((_, plain) => plainToClass(MarketsCompsetMainModel, plain.main_compset, { excludeExtraneousValues: true }) || null)
    document: MarketsCompsetMainModel | null = null;
}

export class RankingClusterHotelDataModel extends ClusterHotelDataModel {
    @Expose()
    @Transform((_, plain) => plainToClass(RankingDocument, plain.main_compset, { excludeExtraneousValues: true }) || null)
    document: RankingDocument | null = null;
}

export class PromotionClusterHotelDataModel extends ClusterHotelDataModel {
    @Expose()
    @Transform((_, plain) => plainToClass(PromotionsDocumentModel, plain.document || null) || null)
    document: PromotionsDocumentModel | null = null;
}

export class InsightClusterHotelDataModel extends ClusterHotelDataModel {
    @Expose()
    @Transform((_, plain) => plainToClass(ClusterInsightsDocumentModel, plain.document || null) || null)
    document: ClusterInsightsDocumentModel | null = null;
}

export class DiLiteClusterHotelDataModel extends ClusterHotelDataModel {
    @Expose()
    @Transform((_, plain) => plainToClass(RatesCompsetMainModel, plain.main_compset, { excludeExtraneousValues: true }))
    document: RatesDocumentAllModel | null = null;
}
interface StatisticData {
    comp_set?: number;
    last_year?: number;
    my_hotel?: number;
    absolute_comp_set?: number;
    absolute_last_year?: number;
    performance_comp_set?: number;
    performance_last_year?: number;
    performance_my_hotel?: number;
    performance_calculated_comp_set?: number;
    performance_calculated_last_year?: number;
}

interface DayStats {
    [days: number]: {
        [statistic: string]: StatisticData
    };
}

interface DeepAnalysisClusterResponse {
    details: {
        [providerKey: string]: {
            currency: string;
            customer_id: string;
            last: DayStats;
            next: DayStats
        };
    };
    update_date: string;
    hotel_name: string;
    fornova_id: number;
}

export default class DeepAnalysisClusterHotelDataModel extends ClusterHotelDataModel {
    @Expose()
    @Transform((_, plain: DeepAnalysisClusterResponse) => {
        if (!plain.details || !Object.keys(plain.details).length) {
            return null;
        }

        const { document } = plainToClass(DeepAnalysisDocumentModel, plain.details, { excludeExtraneousValues: true });

        return document;
    })
    document: DeepAnalysisDocumentModel['document'] | null = null;
}
